// TODO: use it to check what parts of HTTP observability feature is ready
export class FeatureFlags {
  public static default(): FeatureFlags {
    return new FeatureFlags();
  }
}
